export default function combineSignalREvents(){
  let eventsList = {};
  for ( let i=0; i<arguments.length; i++)
    eventsList = {...eventsList, [i]: arguments[i]};
  return eventsList;
}
